import { supabase } from "../supabaseClient"

const invoke = async (body) => {
  const { data, error } = await supabase.functions.invoke("monitoring-google", { body })
  if (error) {
    let payload = null
    if (error.context?.json) {
      try { payload = await error.context.json() } catch (_) {
        // Preserve the function client's message when the body is not JSON.
      }
    }
    const requestError = new Error(payload?.error || error.message || "Google monitoring request failed")
    requestError.code = payload?.code || null
    throw requestError
  }
  if (data?.error) throw new Error(data.error)
  return data || {}
}

export const startMonitoringGoogleOAuth = (organizationId, accountId) => invoke({
  action: "oauth-start",
  organization_id: organizationId,
  account_id: accountId,
})

export const completeMonitoringGoogleOAuth = (organizationId, code, state) => invoke({
  action: "oauth-complete",
  organization_id: organizationId,
  code,
  state,
})

export const discoverMonitoringGoogleResources = (organizationId, accountId, connectionId) => invoke({
  action: "discover",
  organization_id: organizationId,
  account_id: accountId,
  oauth_connection_id: connectionId,
})

export const saveMonitoringPlatformAccounts = (organizationId, accountId, connectionId, resources) => invoke({
  action: "save-platform-accounts",
  organization_id: organizationId,
  account_id: accountId,
  oauth_connection_id: connectionId,
  resources,
})

